module.exports = __webpack_public_path__ + "img/bombas_tipo_jet.90af783f.jpg";